/**
 * Enrollment-code generation: POST /v1/family/endpoints/enroll-code returns a
 * short human-readable code plus an ISO expiry. Parents show the code to the
 * child's laptop during installer setup.
 *
 * No caching or state — one call, one code. Each call mints a new code and
 * invalidates prior unused codes on the server side (see sub-plan 005).
 */

import { api } from '../state/api';

interface EnrollCodeResponse {
  code: string;
  expires_at: string;
}

export interface EnrollmentCode {
  code: string;
  expiresAt: Date;
}

export async function generateEnrollmentCode(): Promise<EnrollmentCode> {
  const resp = await api<EnrollCodeResponse>(
    '/v1/family/endpoints/enroll-code',
    {
      method: 'POST',
    },
  );
  return { code: resp.code, expiresAt: new Date(resp.expires_at) };
}
